import Pages from "layouts/Pages.jsx";
import PagesNoLayout from "layouts/PagesNoLayout.jsx";
import Dashboard from "layouts/Dashboard.jsx";

var indexRoutes = [
  { path: "/pages", name: "Pages", component: Pages },
  { path: "/dashboards", name: "Home", component: Dashboard },
  { path: "/", name: "PagesNoLayout", component: PagesNoLayout },
];

export default indexRoutes;
